import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategorySection() {
  return (
    <section id="topics" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <span className="text-xs font-medium tracking-[0.2em] text-primary-600">CONTENT DIRECTIONS</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            五个入口，按你在意的方向吃瓜
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            每条线索最终都会归到一个方向上：是还原时间线、观察舆论、拆解行业流程，还是练习核对方法。
            选一个入口，剩下的交给我们整理。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:mt-10 md:grid-cols-2 lg:grid-cols-3">
          {categories.map((item) => {
            const count = articles.filter((a) => a.categoryId === item.id).length;
            return (
              <Link
                key={item.id}
                to={`/topics?category=${item.id}`}
                className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-6"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-file-text-line"></i>
                    {count} 篇
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{item.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <span className="mt-4 flex items-center gap-1 text-sm text-primary-700">
                  进入方向
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </Link>
            );
          })}

          <div className="flex flex-col justify-center rounded-lg border border-dashed border-primary-300 bg-primary-50/60 p-5 md:p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-800">
              <i className="ri-lightbulb-flash-line text-xl"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">想看的没被覆盖？</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              把你关注的线索和原始链接发给我们，整理方向由你决定。
            </p>
            <Link
              to="/contact"
              className="mt-4 inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line"></i>
              提交线索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}